var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"leaguge"}},[_c('v-row',{staticClass:"justify-center mt-3 pt-3"},[_c('h1',[_vm._v("Liga")])]),_c('v-row',{staticClass:"justify-center"},[_c('LeagueOverView')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }